import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalContent,
  ButtonProps,
} from '@clearcover/atlas';

import styles from './styles.module.css';

interface WarningModalProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  message: string;
  buttons: (ButtonProps & {
    label: string;
    onClick: () => void;
    closeOnClick: boolean;
    testId: string;
  })[];
}

export const WarningModal: React.FC<WarningModalProps> = ({
  open,
  handleClose,
  title,
  message,
  buttons,
}) => {
  return (
    <Modal
      variant="normal"
      controlled={true}
      open={open}
      handleClose={handleClose}
    >
      {closeModal => (
        <>
          <ModalHeader>
            <h3 className={styles.modalHeader}>{title}</h3>
          </ModalHeader>
          <ModalContent>
            <div className={styles.modalBody}>
              <p>{message}</p>
              <div className={styles.modalButtons}>
                {buttons.map((button, index) => (
                  <Button
                    key={index}
                    block
                    data-testid={button.testId}
                    variant={button.variant}
                    size={button.size}
                    isSubmitting={button.isSubmitting}
                    onClick={() => {
                      button.onClick();
                      if (button.closeOnClick) closeModal(); // Close modal if needed
                    }}
                  >
                    {button.label}
                  </Button>
                ))}
              </div>
            </div>
          </ModalContent>
        </>
      )}
    </Modal>
  );
};
